module.exports = __webpack_public_path__ + "img/location-knsm.23ee1c28.jpg";